/**
 * Nome de moeda para o aviso bloqueante (#299 decisão B, UX 5641191454 §1):
 * «rial saudita (SAR)» via Intl.DisplayNames na língua do painel, com
 * fallback para o código ISO. Cacheado por língua — DisplayNames é caro de
 * construir por render.
 */
const cache = new Map<string, Intl.DisplayNames>()

function displayNames(lang: string): Intl.DisplayNames | null {
  const key = lang || 'pt'
  let dn = cache.get(key)
  if (!dn) {
    try {
      dn = new Intl.DisplayNames([key], { type: 'currency' })
    } catch {
      return null // língua malformada — usa o código
    }
    cache.set(key, dn)
  }
  return dn
}

export function currencyName(code: string, lang: string): string {
  const upper = code.trim().toUpperCase()
  const dn = displayNames(lang)
  if (!dn) return upper
  try {
    const name = dn.of(upper)
    // Intl devolve o próprio código quando não conhece a moeda
    return name && name.toUpperCase() !== upper ? `${name} (${upper})` : upper
  } catch {
    return upper
  }
}
